import type { JSX } from 'react';

const LoadingSpinner = (props: { isWhiteSpinner?: boolean; message?: string | JSX.Element }) => (
    <div data-testid='loading-spinner' className={'loading center ' + (props.isWhiteSpinner ? 'white-spinner' : '')}>
        <div className="spinner">
            <div className="cube1" />
            <div className="cube2" />
        </div>
        {props.message
            ? <p>{props.message}</p>
            : null
        }
    </div>
);

export default LoadingSpinner;